import { UseFormRegister, FieldErrors } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { EventFormData } from "./types";

interface EventDateTimeProps {
  register: UseFormRegister<EventFormData>;
  errors: FieldErrors<EventFormData>;
}

const EventDateTime = ({ register, errors }: EventDateTimeProps) => {
  return (
    <div className="grid grid-cols-2 gap-6">
      <div className="space-y-2">
        <Label htmlFor="startTime">Start Time</Label>
        <Input
          id="startTime"
          type="datetime-local"
          {...register("startTime", { required: true })}
          className={errors.startTime ? "border-red-500" : ""}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="endTime">End Time</Label>
        <Input
          id="endTime"
          type="datetime-local"
          {...register("endTime", { required: true })}
          className={errors.endTime ? "border-red-500" : ""}
        />
      </div>
    </div>
  );
};

export default EventDateTime;